class RoleModel {
  name!: string;
  isStatic: boolean = false;
  displayName!: string;
  description?: any;
  id!: number;
}

export default RoleModel;
